import { Avatar, Flex } from 'antd';
import './TopicGroup.scss';
export default function TopicGroup() {
  return (
    <Flex className='topic-group' vertical align='center'>
      <div className='topic-group-item'>
        <Avatar shape='square' size='default' className='topic-group-avatar'>
          TICKET
        </Avatar>
      </div>
    </Flex>
  );
}
